import { ReactNode } from 'react';
import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { instance } = useMsal();
  const hasActiveAccount = !!instance.getActiveAccount();

  if (!hasActiveAccount) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default ProtectedRoute;
